import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { MessageCircle, Phone, KeyRound, ArrowLeft } from "lucide-react";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import { useClientTheme } from "@/contexts/ThemeContext";

export default function ForgotPassword() {
  const { i18n } = useTranslation();
  const isEN = i18n.language === "en";
  const { theme } = useClientTheme();
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-5" data-theme={theme} data-testid="forgot-root">
      <div className="absolute top-5 right-5 z-10"><ThemeSwitcher /></div>
      <div className="max-w-md w-full bg-zinc-900/60 border border-zinc-800 rounded-xl p-6 space-y-5" data-testid="forgot-password-page">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700]">{isEN ? "Password recovery" : "Recupero password"}</p>
          <h1 className="font-display text-3xl font-bold mt-1 flex items-center gap-2">
            <KeyRound className="w-6 h-6 text-[#FFD700]" /> {isEN ? "Forgot password?" : "Password dimenticata?"}
          </h1>
        </div>

        <div className="rounded-xl border border-zinc-800 bg-zinc-950/40 p-5 space-y-4">
          <p className="text-sm text-zinc-300 leading-relaxed">
            {isEN
              ? "We are a small family-run rental on Elba island. To reset your password, contact us directly — we'll provide a temporary password by voice. You'll be asked to choose a new one at first login."
              : "Siamo una piccola realtà familiare sull'Elba. Per reimpostare la password, contattaci direttamente — ti forniremo una password temporanea a voce. Al primo accesso potrai sceglierne una nuova."}
          </p>
          <div className="grid grid-cols-1 gap-2">
            <a href="https://wa.me/390565904134" target="_blank" rel="noopener noreferrer">
              <Button className="w-full bg-green-500/15 hover:bg-green-500/25 border border-green-500/40 text-green-300 justify-start" data-testid="forgot-whatsapp">
                <MessageCircle className="w-4 h-4 mr-2" /> {isEN ? "WhatsApp +39 0565 904134" : "WhatsApp +39 0565 904134"}
              </Button>
            </a>
            <a href="tel:+390565904134">
              <Button variant="outline" className="w-full bg-zinc-900 border-zinc-800 hover:bg-zinc-800 text-zinc-100 justify-start" data-testid="forgot-call">
                <Phone className="w-4 h-4 mr-2" /> {isEN ? "Call +39 0565 904134" : "Chiama +39 0565 904134"}
              </Button>
            </a>
          </div>
          <p className="text-xs text-zinc-500 leading-relaxed">
            {isEN
              ? "Mon-Sun 9:00-19:00 — Marciana Marina, Elba Island"
              : "Lun-Dom 9:00-19:00 — Marciana Marina, Isola d'Elba"}
          </p>
        </div>

        <Link to="/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-[#FFD700]" data-testid="forgot-back-login">
          <ArrowLeft className="w-3 h-3" /> {isEN ? "Back to login" : "Torna al login"}
        </Link>
      </div>
    </div>
  );
}
